// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --karry: 29, 100%, 92%; /* #FFE9D5*/
  --matterhorn: 324, 13%, 23%;
  --persimmon: 7.326, 100%, 66%; /*#FF6853*/
  --romantic: hsl(17.746, 100%, 86%); /*#FFCDB8*/
  --romantic-00: hsla(16, 100%, 87%, 0); /*#FFCDB8*/
  --salmon: hsl(16.107, 100%, 71%); /* #FF926A */
  --salmon-50: hsla(16, 100%, 71%, 0.5); /* #FF926A */
  --seashellPeach: hsl(26.667, 100%, 97%); /*#FFF5ED*/
  --white: hsl(0, 0%, 100%);
  --macaroniAndCheese: hsl(28, 100%, 75%, 1); /*#FFBB80*/
  --macaroniAndCheese-60: hsla(28, 100%, 75%, 0.6); /*#FFBB80*/
}

.background-gradient {
  background: linear-gradient(to bottom, var(--seashellPeach), var(--romantic));
}

.background-gradient-second {
  background: linear-gradient(
    to bottom,
    hsl(var(--karry)),
    var(--seashellPeach)
  );
}

.background-gradient-articles {
  background: linear-gradient(to right, #fff5ed, #fff7f1cc);
}

.background-gradient-page {
  background: linear-gradient(to bottom, var(--white), var(--white));
}

.background-gradient-event {
  background: linear-gradient(
    to bottom,
    hsla(var(--matterhorn), 0.08),
    hsla(var(--matterhorn), 1)
  );
}

.background-gradient-you {
  background: linear-gradient(to bottom, var(--romantic-00), var(--salmon-50));
}

.box-shadow-articles {
  box-shadow: 0 0 30px 0 hsla(7, 100%, 66%, 0.23);
}

.box-shadow-form {
  box-shadow: 0 8px 30px 0 hsla(7, 100%, 66%, 0.23);
}

.background-blur {
  backdrop-filter: blur(20px);
}

.clip-path {
  position: relative;
  margin-left: -2px;
  margin-right: -2px;
  width: 64px;
  height: 80px;
  background-color: var(--white);
  clip-path: path("M 0 84 L 0 12 A 32 32 0 0 0 64 12 L 64 88 Z");
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui-components/src/styles/constants.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB,EAAE,WAAW;EACnC,2BAA2B;EAC3B,6BAA6B,EAAE,UAAU;EACzC,kCAAkC,EAAE,UAAU;EAC9C,qCAAqC,EAAE,UAAU;EACjD,gCAAgC,EAAE,YAAY;EAC9C,qCAAqC,EAAE,YAAY;EACnD,uCAAuC,EAAE,UAAU;EACnD,yBAAyB;EACzB,0CAA0C,EAAE,UAAU;EACtD,gDAAgD,EAAE,UAAU;AAC9D;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,8DAA8D;AAChE","sourcesContent":[":root {\n  --karry: 29, 100%, 92%; /* #FFE9D5*/\n  --matterhorn: 324, 13%, 23%;\n  --persimmon: 7.326, 100%, 66%; /*#FF6853*/\n  --romantic: hsl(17.746, 100%, 86%); /*#FFCDB8*/\n  --romantic-00: hsla(16, 100%, 87%, 0); /*#FFCDB8*/\n  --salmon: hsl(16.107, 100%, 71%); /* #FF926A */\n  --salmon-50: hsla(16, 100%, 71%, 0.5); /* #FF926A */\n  --seashellPeach: hsl(26.667, 100%, 97%); /*#FFF5ED*/\n  --white: hsl(0, 0%, 100%);\n  --macaroniAndCheese: hsl(28, 100%, 75%, 1); /*#FFBB80*/\n  --macaroniAndCheese-60: hsla(28, 100%, 75%, 0.6); /*#FFBB80*/\n}\n\n.background-gradient {\n  background: linear-gradient(to bottom, var(--seashellPeach), var(--romantic));\n}\n\n.background-gradient-second {\n  background: linear-gradient(\n    to bottom,\n    hsl(var(--karry)),\n    var(--seashellPeach)\n  );\n}\n\n.background-gradient-articles {\n  background: linear-gradient(to right, #fff5ed, #fff7f1cc);\n}\n\n.background-gradient-page {\n  background: linear-gradient(to bottom, var(--white), var(--white));\n}\n\n.background-gradient-event {\n  background: linear-gradient(\n    to bottom,\n    hsla(var(--matterhorn), 0.08),\n    hsla(var(--matterhorn), 1)\n  );\n}\n\n.background-gradient-you {\n  background: linear-gradient(to bottom, var(--romantic-00), var(--salmon-50));\n}\n\n.box-shadow-articles {\n  box-shadow: 0 0 30px 0 hsla(7, 100%, 66%, 0.23);\n}\n\n.box-shadow-form {\n  box-shadow: 0 8px 30px 0 hsla(7, 100%, 66%, 0.23);\n}\n\n.background-blur {\n  backdrop-filter: blur(20px);\n}\n\n.clip-path {\n  position: relative;\n  margin-left: -2px;\n  margin-right: -2px;\n  width: 64px;\n  height: 80px;\n  background-color: var(--white);\n  clip-path: path(\"M 0 84 L 0 12 A 32 32 0 0 0 64 12 L 64 88 Z\");\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
